import { Form, Icon } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC } from 'react';
import * as Styles from './select.module.less';

export const SearchInput: FC<{
    className?: string;
    placeholder?: string;
    search: string;
    setSearch(val: string): void;
}> = ({ className, placeholder, search, setSearch }) => (
    <Form.Input
        value={search}
        className={classNames(Styles.inputSearch, className)}
        icon={search ? { name: 'close', size: 16, onClick: () => setSearch('') } : undefined}
        onChange={(e: any) => setSearch(e.target?.value ?? '')}
        shortLabel={<Icon name="search" />}
        placeholder={placeholder}
    />
);
